import { render, staticRenderFns } from "./returnPayFee.vue?vue&type=template&id=56c917bf"
import script from "./returnPayFee.vue?vue&type=script&lang=js"
export * from "./returnPayFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports